module.exports = "/images/axa.png?c78f03112ad4e3b129c2f113c7392465";